import React from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
} from 'reactstrap';
import { GetFormattedDate, getAge } from './FormatDate';
import dog from '../Images/dog.png';
import cat from '../Images/cat.png';
import all from '../Images/all.jpg';

const PetDataComponent = ({ petData }) => (
  <>
    <Card outline color="secondary">
      <Row>
        <Col xs="9" md="9">
          <CardBody>
            {petData.name && (
              <div>
                Name :
                {' '}
                {petData.name}
              </div>
            )}
            {petData.type && (
              <div>
                Type :
                {' '}
                {petData.type.label}
              </div>
            )}
            {petData.breed && (
              <div>
                Breed :
                {' '}
                {petData.breed.label}
              </div>
            )}
            {petData.color && (
              <div>
                Color :
                {' '}
                {petData.color.label}
              </div>
            )}
            {petData.gender && (
              <div>
                Gender :
                {' '}
                {petData.gender}
              </div>
            )}
            {petData.dob && (
              <>
                <div>
                  Date of Birth:
                  {' '}
                  {GetFormattedDate(petData.dob.seconds * 1000)}
                </div>
                <div>
                  Age:
                  {' '}
                  {getAge(petData.dob.seconds)}
                </div>
              </>
            )}
          </CardBody>
        </Col>
        <Col xs="3" md="3">
          {petData.type && (
            <div>
              {(petData.type.label.toLowerCase() === ('canine')) && (
              <div style={{ lineHeight: '150px', textAlign: 'center' }}>
                <img
                  style={{
                    width: '100px', height: '100px', right: '50px', position: 'relative',
                  }}
                  src={dog}
                  alt="dog"
                />
              </div>
              )}
              {(petData.type.label.toLowerCase() === 'feline') && (
              <div style={{ lineHeight: '150px', textAlign: 'center' }}>
                <img
                  style={{
                    width: '100px', height: '100px', right: '50px', position: 'relative',
                  }}
                  src={cat}
                  alt="cat"
                />
              </div>
              )}
              {(petData.type.label.toLowerCase() === 'other') && (
              <div style={{ lineHeight: '150px', textAlign: 'center' }}>
                <img
                  style={{
                    width: '100px', height: '100px', right: '50px', position: 'relative',
                  }}
                  src={all}
                  alt="all"
                />
              </div>
              )}
            </div>
          )}
        </Col>
      </Row>
    </Card>
  </>
);

export default PetDataComponent;
